import styled from "styled-components";
import { ButtonBase } from "@mui/material";
import { THEME } from "../../styles/theme";

export const ItemButton = styled(ButtonBase)<{ selected: boolean }>`
  width: 100%;
  background-color: ${THEME.palette.background.paper};
  color: ${({ selected, disabled }) =>
    disabled
      ? THEME.palette.divider
      : selected
        ? THEME.palette.primary.main
        : THEME.palette.text.secondary};
  * {
    font-weight: ${({ selected }) => (selected ? 500 : 400)} !important;
  }
  border: 1px solid
    ${({ selected }) =>
      selected ? THEME.palette.primary.main : THEME.palette.divider};
  border-radius: 0.75rem;
  padding: 0.5rem 1rem;
`;

export const ItemInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-right: auto;
  > label {
    font-size: 0.65rem;
    font-weight: 400;
  }
`;

export const ItemPriceAndTime = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  > label {
    font-size: 0.65rem;
    font-weight: 400;
  }
`;

export const DaysContainer = styled.div`
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
  gap: 0.5rem;
`;

export const Day = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  > label {
    &:first-child {
      text-transform: uppercase;
      font-size: 1rem;
      margin-bottom: 0.3rem;
      margin-top: 0.5rem;
    }
    &:last-child {
      text-transform: capitalize;
      font-size: 0.6rem;
      margin-bottom: 0.1rem;
    }
    line-height: 0;
    opacity: 0.8;
  }
`;

export const ProfessionalBox = styled.div`
  background-color: ${THEME.palette.background.paper};
  padding: 1rem;
  border-radius: 0.75rem;
  border: 1px solid ${THEME.palette.divider};
`;

export const ProfessionalHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
`;
